// Imports
import styled from 'styled-components/macro';
import Rating from './rating';
import ratings from './ratings';


// Styled components
const Wrapper = styled.div`
	display: flex;
	justify-content: center;
	gap: 5rem;
	flex-wrap: wrap;
	
	margin-top: 2.5rem;
	
	@media (max-width: 48rem) {
		gap: 2.5rem 1.5rem;
		display: grid;
		grid-template-columns: repeat(2, 1fr);
	}
`;


// Function component
const Ratings: React.FC = () => (
	<Wrapper>
		{ratings.map((rating, i) => (
			<Rating key={i} {...rating} />
		))}
	</Wrapper>
);

export default Ratings;
